import React, { useContext } from 'react';

import T from 'utils/useLocalizer';
import SelectField from 'components/form/input/SelectField';
import Tooltip from 'components/ui/tooltip/CustomTooltip';
import { InfoCircle } from 'react-bootstrap-icons';
import { OrderWAPhoneEmptyContext } from './OrderWAPhoneEmptyContext';
import { ISelectItem } from 'models/commonModel';

export interface Props {
  inputProps: any;
  toolTipId: string;
  waTemplateList: ISelectItem<string | number>[];
  isLoadingTemplateList: boolean;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const OrderStatusWATemplateForm = ({ inputProps, toolTipId, waTemplateList, isLoadingTemplateList, onChange }: Props) => {
  const isDisabled = useContext(OrderWAPhoneEmptyContext);
  const resources = {
    notificationTemplateConstraints: T('orders.order.settings.notification.template.constraints.hint.message'),
  };

  return (
    <div className="d-flex align-items-center gap-2 my-2">
      <SelectField itemsList={waTemplateList} size="sm" isLoading={isLoadingTemplateList} inputProps={inputProps} disabled={isDisabled} onChange={onChange} />{' '}
      <span>
        <span data-tooltip-id={toolTipId} className="f-s-12 text-muted ms-2">
          <InfoCircle size={12} />
        </span>
        <Tooltip id={toolTipId}>
          <div className="fw-normal">{resources.notificationTemplateConstraints}</div>
        </Tooltip>
      </span>
    </div>
  );
};

export default OrderStatusWATemplateForm;
